module.exports = __webpack_public_path__ + "files/47f27005d8d00cd698341651a80a4fbf.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/robotoslab-bold-webfont.svg
 ** module id = 1006
 ** module chunks = 0
 **/